import dayjs from "dayjs";

interface DateDifference {
  days: number;
  hours: number;
}

export const getDateDifference = (
  firstDate: string,
  secondDate: string
): DateDifference => {
  const date1 = dayjs(firstDate);
  const date2 = dayjs(secondDate);

  if (!date1.isAfter(date2)) {
    return { days: 0, hours: 0 };
  }

  // Adding 1 to ensure we count the minute difference correctly
  const totalMinutes = date1.diff(date2, "minute") + 1;

  const totalHours = Math.floor(totalMinutes / 60);

  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  return { days, hours };
};

export default getDateDifference;
